import { RGBELoader } from 'three/addons/loaders/RGBELoader.js'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'

export default function createLoaders()
{
  const rgbeLoader = new RGBELoader()

  const dracoLoader = new DRACOLoader()
  dracoLoader.setDecoderPath('./draco/')

  const gltfLoader = new GLTFLoader()
  gltfLoader.setDRACOLoader(dracoLoader)

  return { rgbeLoader, gltfLoader, dracoLoader }
}
